export { default } from './FormControl';
//# sourceMappingURL=index.js.map